'use strict';
export default class GraphViewSet {

    /**
     * @description 通常设置
     * @static
     * @param {object} gv 二维拓扑节点
     * @memberof GraphViewSet
     */
    static commonSetting(gv) {
        // 禁止鼠标缩放
        gv.handleScroll = () => { };
        // 禁止 touch 下双指缩放
        gv.handlePinch = () => { };
        // 禁止平移
        gv.setPannable(false);
        // 禁止框选
        gv.setRectSelectable(false);
        // 隐藏滚动条
        gv.setScrollBarVisible(false);
        // 选中边框为0
        gv.getSelectWidth = () => 0;
        // 禁止图元移动
        gv.setMovableFunc(()=> { return false });
    }

    /**
     * @description 设置视图的 style
     * @static
     * @param {object} view 视图
     * @memberof GraphViewSet
     */
    static styleSetting(view) {
        let style = view.style;
        style.top = 0;
        style.left = 0;
        style.bottom = 0;
        style.right = 0;
    }

    /**
     * @description body 设置 transform scale 问题
     * @static
     * @param {object} gv 二维拓扑节点
     * @memberof GraphViewSet
     */
    static transformBugSetting(gv) {
        gv.getView().updateAppendMatrix = true;
    }

    /**
     * @description 避免 2D 和 3D 的交互重叠
     * @static
     * @param {object} gv 二维拓扑节点
     * @memberof GraphViewSet
     */
    static interaction2D3D(gv) {
        let div2d = gv.getView();
        let handler = event => {
            if (gv.getDataAt(event)) {
                event.preventDefault();
                event.stopPropagation();
            }
        }
        div2d.addEventListener('mousedown', handler);
        div2d.addEventListener('touchstart', handler);
        div2d.addEventListener('mousewheel', handler);
    }

}
